if(document.querySelector('.what-they-say-slider')) {
    var swiper = new Swiper('.what-they-say-slider', {
        slidesPerView: 1.5,
        spaceBetween: 12,
        pagination: {
        el: '.swiper-pagination',
        spaceBetween: 12,
        clickable: true
        },
        navigation: {
            nextEl: '.swiper-slider-wrapper .swiper-arrow-next',
            prevEl: '.swiper-slider-wrapper .swiper-arrow-prev',
        },
        breakpoints: {
            10: {
                slidesPerView: 1.3,
                centeredSlides: true,
                infinate: true,
                loop: true,
            },
            767:{
                slidesPerView: 2,
                centeredSlides: false,
            },
            900: {
                slidesPerView: 3,
                spaceBetween: 20,

            },
            1025: {
                slidesPerView: 4,
            },
        }
    });
}

if(document.querySelector('.testimonial-slider')) {
    var swiper = new Swiper('.testimonial-slider', {
        slidesPerView: 1.5,
        spaceBetween: 16,
        pagination: {
        el: '.testimonial-carousel-section .swiper-pagination',
        spaceBetween: 16,
        clickable: true
        },
        navigation: {
            nextEl: '.swiper-slider-wrapper .swiper-arrow-next',
            prevEl: '.swiper-slider-wrapper .swiper-arrow-prev',
        },
        breakpoints: {
            10: {
                centeredSlides: true,
                infinate: true,
                loop: true,
                slidesPerView: 1.3,
            },
            767:{
                slidesPerView: 2,
                centeredSlides: false,

            },
            900: {
                slidesPerView: 3,
            },
            1025: {
                slidesPerView: 3,
                spaceBetween: 20,

            },
        }
    });
}

//:: START :: PRODUCT COMPARISON :: ==================

if(document.querySelector('.other-product-slider')) {
    var swiper = new Swiper('.other-product-slider', {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        navigation: {
            nextEl: '.last-other-box .next-arrow',
            prevEl: '.last-other-box .prev-arrow',
        },
    });
}

//:: END :: PRODUCT COMPARISON :: ==================

document.querySelectorAll('.video-story-block').forEach((container) => {
  const video = container.querySelector('video');
  const playIcon = container.querySelector('.play_icon');
  const pauseIcon = container.querySelector('.pause_icon');

  // Toggle play/pause when clicking play/pause icon
  container.querySelectorAll('.play_icon, .pause_icon').forEach((icon) => {
    icon.addEventListener('click', () => {
      if (video.paused) {
        pauseOtherVideos(video);
        video.play();
      } else {
        video.pause();
      }
    });
  });

  // --- PLAY ON HOVER ---
  container.addEventListener('mouseenter', () => {
    if (video.paused) {
      pauseOtherVideos(video);
      video.play();
    }
  });

  // --- PAUSE ON HOVER OUT ---
  container.addEventListener('mouseleave', () => {
    if (!video.paused) {
      video.pause();
    }
  });

  // Video is playing
  video.addEventListener('play', () => {
    container.classList.add('video-playing');
    container.classList.remove('video-paused');
    playIcon.style.display = 'none';
    pauseIcon.style.display = 'block';
    video.setAttribute('controls', true);
  });

  // Video is paused or ended
  const resetVideo = () => {
    container.classList.remove('video-playing');
    container.classList.add('video-paused');
    playIcon.style.display = 'block';
    pauseIcon.style.display = 'none';
    video.removeAttribute('controls');
  };
  video.addEventListener('pause', resetVideo);
  video.addEventListener('ended', resetVideo);

  // Helper: pause all other videos
  function pauseOtherVideos(current) {
    document.querySelectorAll('.video-story-block video').forEach(v => {
      if (v !== current) {
        v.pause();
      }
    });
  }
});


// Product Media Slider Js Start

if (document.querySelector('.product_thumbnail_slider') && document.querySelector('.product-top-slider')) {
    var thumbnail_slider = new Swiper('.product_thumbnail_slider', {
        slidesPerView: 4.5,
        freeMode: true,
        watchSlidesProgress: true,
        spaceBetween: 10,
        navigation: {
            nextEl: '.prod-swiper-button-next',
            prevEl: '.prod-swiper-button-prev',
        },
        breakpoints: {
             1199: {
                slidesPerView: 6.3,
            },
            899: {
                slidesPerView: 5.3,
            },
            767: {
                slidesPerView: 4.3,
            },
        }
    });

    var product_top_slider = new Swiper('.product-top-slider', {
        slidesPerView: 1.1,
        spaceBetween: 10,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        navigation: {
            nextEl: '.prod-swiper-button-next',
            prevEl: '.prod-swiper-button-prev',
        },
        thumbs: {
            swiper: thumbnail_slider
        },
        breakpoints: {
            767: {
                slidesPerView: 1,
            },
        }
    });
}


// Product Media Slider End

// PRODUCT DETAILS PAGE FOR TIMER START FOR SHIPPING HOURS JS START
/*document.addEventListener("DOMContentLoaded", function () {
    if (typeof durationStr !== "undefined") {
        
        var durationHours = parseFloat(durationStr);

        // Fallback if value is invalid
        if (isNaN(durationHours) || durationHours <= 0) {
            durationHours = 3; // default 3 hours
        }

        var durationMs = durationHours * 60 * 60 * 1000; // convert hours to milliseconds
        var timerEl = document.getElementById("order_timmer");

        if (!timerEl) {
            console.error("❌ Timer element with id 'order_timmer' not found!");
            return;
        }

        // Check if an end time is already stored
        var storedEndTime = localStorage.getItem("countdownEnd");
        var endTime;

        if (storedEndTime && !isNaN(storedEndTime)) {
            endTime = parseInt(storedEndTime);
        } else {
            endTime = Date.now() + durationMs;
            localStorage.setItem("countdownEnd", endTime);
        }

        function updateTimer() {
            var now = Date.now();
            var remaining = endTime - now;

            if (remaining <= 0) {
                console.log("⏰ Timer finished, hiding element...");
                timerEl.style.setProperty("display", "none", "important"); // force hide
                localStorage.removeItem("countdownEnd");
                clearInterval(timerInterval);
                return;
            }

            var totalSeconds = Math.floor(remaining / 1000);
            var h = Math.floor(totalSeconds / 3600);
            var m = Math.floor((totalSeconds % 3600) / 60);
            var s = totalSeconds % 60;

            function pad(n) {
                return n < 10 ? "0" + n : n;
            }

            timerEl.textContent = pad(h) + ":" + pad(m) + ":" + pad(s);
        }

        updateTimer(); // initial render
        var timerInterval = setInterval(updateTimer, 1000);
    }
});*/
document.addEventListener("DOMContentLoaded", function () {

    const timerEl = document.getElementById("order_timmer");
    const order_timmer = document.querySelector(".order-within-wrappepr");
    if (!timerEl) return;

    function checkTimer() {

        const now = new Date();

        // Convert to Australia/Sydney time
        const sydneyTime = new Date(
            now.toLocaleString("en-US", { timeZone: "Australia/Sydney" })
        );

        const currentHour = sydneyTime.getHours();

        // If 12 PM or later → hide timer
        if (currentHour >= 12) {
            order_timmer.style.display = "none";
            return;
        }

        // Otherwise show timer
        order_timmer.style.display = "flex";

        const target = new Date(sydneyTime);
        target.setHours(12, 0, 0, 0);

        const remaining = target - sydneyTime;

        const totalSeconds = Math.floor(remaining / 1000);
        const h = Math.floor(totalSeconds / 3600);
        const m = Math.floor((totalSeconds % 3600) / 60);
        const s = totalSeconds % 60;

        timerEl.textContent =
            String(h).padStart(2, "0") + ":" +
            String(m).padStart(2, "0") + ":" +
            String(s).padStart(2, "0");
    }

    checkTimer();
    setInterval(checkTimer, 1000);

});
// PRODUCT DETAILS PAGE FOR TIMER START FOR SHIPPING HOURS JS END

// CART DRAWER ORDER RESERVED TIMEER JS START
function startUserTimer(minutes) {
    const timerDiv = document.getElementById('product-reserved-timer');
    const timerMain = document.getElementById('product-reserved-timer-main');

    if (!timerDiv || !timerMain) {
        console.warn("Timer elements not found in DOM.");
        return;
    }

    const storageKey = 'user_timer_end';
    let endTime = localStorage.getItem(storageKey);
    if (!endTime) {
        endTime = new Date().getTime() + minutes * 60 * 1000;
        localStorage.setItem(storageKey, endTime);
    } else {
        endTime = parseInt(endTime);
    }
    //console.log("ennnnd",endTime);
    const interval = setInterval(() => {
        const now = new Date().getTime();
        let distance = endTime - now;

        if (distance <= 0) {
            clearInterval(interval);
            timerDiv.style.display = 'none';
            localStorage.removeItem(storageKey);
            timerMain.style.display = 'none';
            return;
        }

        const hours = Math.floor(distance / (1000 * 60 * 60));
        const mins = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const secs = Math.floor((distance % (1000 * 60)) / 1000);

        timerDiv.innerHTML = `${hours.toString().padStart(2,'0')}:${mins.toString().padStart(2,'0')}:${secs.toString().padStart(2,'0')}`;
    }, 1000);
}
// Start a 5-minute timer for the current user
startUserTimer(1);
const checkCartItemCount = setInterval(() => {
  const cartDrawer = document.querySelector('.cart-drawer__content');
  const cartItemCount = cartDrawer?.querySelector('[ref="cartItemCount"]');

  if (cartItemCount) {
    // Element is found, clear the interval
    startUserTimer(1);
    clearInterval(checkCartItemCount);
    console.log('Found cartItemCount element:', cartItemCount);
  } else {
    // Not found yet, you can run code here if needed
    console.log('Not found yet, checking again…');
  }
}, 500);

//shop now sticky button click to trigger atc button js start
var base = document.querySelector('.custom-section-content .atc-button');
if(base!=null){
  base.addEventListener('click', function(event) {
    var formButton = document.querySelector('.buy-buttons-block .shopify-product-form');
    if(formButton){
      const addBtn = formButton.querySelector('button[name="add"]');
      if (!addBtn) return;
      addBtn.click();
    }
  });
}
//shop now sticky button click to trigger atc button js end

window.addEventListener("scroll", function() {
  const header = document.querySelector("header"); // change selector if needed
  if (window.scrollY > 100) {
    header.classList.add("scrolled");
  } else {
    header.classList.remove("scrolled");
  }
});


// CART DRAWER ORDER RESERVED TIMEER JS END

//VARIANT WISE PRICE CHANGE FOR ATC BUTTON TEXT JS START
// document.querySelector('.variant-option__select').addEventListener("change", function(e) {
//     var targetElement = e.target;
//     setTimeout(function(){
//         const selectedOption = targetElement.options[targetElement.selectedIndex];
//         const itemPrice = selectedOption.dataset.price;
//         const itemCPrice = selectedOption.dataset.cprice;

//         const priceWraper = document.querySelector('.atc_product__price');
//         if (priceWraper) {
//             const compareEl = priceWraper.getElementsByClassName("compare_at_price")[0];
//             if (compareEl) {
//                 if (itemCPrice && itemCPrice !== "") {
//                     compareEl.style.display = "inline";
//                     compareEl.innerHTML = itemCPrice;
//                 } else {
//                     compareEl.style.display = "none";
//                 }
//             }

//             // Update main price
//             const strongEl = priceWraper.getElementsByTagName("strong")[0];
//             if (strongEl && itemPrice && itemPrice !== "") {
//                 strongEl.innerHTML = itemPrice;
//             }
//         }
//     },1100);
// });

//VARIANT WISE PRICE CHANGE FOR ATC BUTTON TEXT JS END

document.addEventListener("DOMContentLoaded", function () {
  const sizeSelect = document.querySelector("#custom_dogsize");

  if (sizeSelect && sizeSelect.options.length > 1) {
    sizeSelect.selectedIndex = 1; // selects the second option (index starts at 0)
    
    // Trigger the 'change' event so any listeners (like your updatePlans function) run
    sizeSelect.dispatchEvent(new Event("change"));
  }

  // Each dog size now has 2 frequency plans
  const plans = {
    "0-10 kg": [".frqplan-60-days0-10kg", ".frqplan-120-days0-10kg", ".frqplan-180-days0-10kg"],
    "10-30 kg": [".frqplan-30-days10-30kg", ".frqplan-60-days10-30kg", ".frqplan-90-days10-30kg"],
    "30+ kg": [".frqplan-20-days30-kg", ".frqplan-40-days30-kg", ".frqplan-60-days30-kg"]
  };

  const allPlans = document.querySelectorAll(".frqplan_name_item:not(.frqplan-onetime)");
  const oneTime = document.querySelector(".frqplan-onetime");

  // Create / get hidden line item property for frequency
  let freqProperty = document.querySelector("input[name='properties[Frequency]']");
  if (!freqProperty) {
    freqProperty = document.createElement("input");
    freqProperty.type = "hidden";
    freqProperty.name = "properties[Frequency]";
    freqProperty.value = ""; // default
    if(document.querySelector("product-form-component form")!=null){
      document.querySelector("product-form-component form").appendChild(freqProperty);
    }
  }

  function updatePlans() {
    if (sizeSelect != null) {
      const selectedSize = sizeSelect.value;

      //console.log("allPlans",allPlans);
      // Hide all frequency plans first
      allPlans.forEach(plan => (plan.style.display = "none"));

      // Show the matching frequency plans
      if (plans[selectedSize]) {
        let firstRadio = null;
        var quantityRadio = 1;
        plans[selectedSize].forEach((selector, index) => {
          const planToShow = document.querySelector(selector);
          if (planToShow) {
            planToShow.style.display = "block";
            var radioSelect = planToShow.querySelector(".selling-plan-radio");
            radioSelect.setAttribute('data-quantity',quantityRadio);
            
            if (index === 0) {
              const planRadio = planToShow.querySelector(".selling-plan-radio");
              if (planRadio) {
                planRadio.checked = true;
                setTimeout(() => {
                  updateHiddenSellingPlan(planRadio);
                }, 300);
              }
            }
            quantityRadio++;
            var planAllRadio = planToShow.querySelector(".selling-plan-radio");
            updateAllPlanDaysPrice(planAllRadio);
          }
        });
      }
    }

    // Always show one-time option (but not auto-select)
    if (oneTime) oneTime.style.display = "block";
  }

  function updateHiddenSellingPlan(radio) {
    const hiddenInput1 = document.querySelector('input[name="selling_plan"]');
    if (radio && hiddenInput1) {
      hiddenInput1.value = radio.value; // sync hidden input
      var variant_quantity = radio.getAttribute('data-quantity');
      var getDiscount = radio.getAttribute('data-discount');
      var priceMain = radio.getAttribute('data-price');
      var comparePrice = radio.getAttribute('data-c-price');
      // Auto-select the first option only
      var calc_main_price = priceMain;
      if(getDiscount!="" && getDiscount!=undefined && priceMain!="" && priceMain!=undefined){
        var amount_discount = (priceMain*getDiscount);
        var amount_discount = (amount_discount/100);
        calc_main_price = (priceMain-amount_discount);
        comparePrice = priceMain; 
      }
      const form = document.querySelector('.shopify-product-form');
      
      var final_compare_price = 0;
      var final_main_price = 0;
      if(comparePrice!=undefined && comparePrice!=""){
        final_compare_price = (parseInt(comparePrice)*parseInt(variant_quantity));
        var comparePriceEl = form.querySelector('.atc_product__price .compare_at_price');
        if(comparePriceEl!=null){
          final_compare_price = Shopify.formatMoney(final_compare_price);
          //console.log("final_compare_price",final_compare_price);
          comparePriceEl.innerHTML=final_compare_price;
        }
        if(document.querySelector('.buy-once-wrapper a')!=null){
          var compareBuyOnePriceEl = document.querySelector('.buy-once-wrapper a');
          //console.log("final_compare_price",final_compare_price);
          compareBuyOnePriceEl.innerHTML='Buy once for '+Shopify.formatMoney(final_compare_price)+' + shipping';
        }
      }
      if(calc_main_price!=undefined && calc_main_price!=""){
        final_main_price = (parseInt(calc_main_price)*parseInt(variant_quantity));
        var mainPriceEl = form.querySelector('.atc_product__price strong');
        final_main_price = Shopify.formatMoney(final_main_price);
        //console.log("final_compare_price",final_main_price);
        mainPriceEl.innerHTML=final_main_price;
      }

      const stickyPriceEl = document.querySelector(".product-sticky-cta .product--price span");
      if(stickyPriceEl!=null){
        stickyPriceEl.textContent = final_main_price;
      }
     
      let hiddenSellField = form.querySelector('#hiddenSellplanid');
      
      if (!hiddenSellField) {
        // Create it if it doesn't exist
        hiddenSellField = document.createElement('input');
        hiddenSellField.type = 'hidden';
        hiddenSellField.id = 'hiddenSellplanid';
        hiddenSellField.name = 'properties[__custom_selling_id]';
        hiddenSellField.value=radio.value;
        form.appendChild(hiddenSellField);
      }else{
        hiddenSellField.value=radio.value;
      }

      if(document.querySelector('#custom_dogsize')!=null){
        var dogSize = document.querySelector('#custom_dogsize').value;
        let dogSizeField = form.querySelector('#hiddenDogsize');
        
        if (!dogSizeField) {
          // Create it if it doesn't exist
          dogSizeField = document.createElement('input');
          dogSizeField.type = 'hidden';
          dogSizeField.id = 'hiddenDogsize';
          dogSizeField.name = 'properties[__custom_dog_size]';
          dogSizeField.value=dogSize;
          form.appendChild(dogSizeField);
        }else{
          dogSizeField.value=dogSize;
        }
      }

      let hiddenField = form.querySelector('#hiddenQuantity');
      
      if (!hiddenField) {
        // Create it if it doesn't exist
        hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.id = 'hiddenQuantity';
        hiddenField.name = 'quantity';
        hiddenField.value=variant_quantity;
        form.appendChild(hiddenField);
      }else{
        hiddenField.value=variant_quantity;
      }
      if(getDiscount!="" && getDiscount!=undefined){
        // --- Custom Main Price ---
        let customDiscountField = form.querySelector('#customDiscount');
        if (!customDiscountField) {
          customDiscountField = document.createElement('input');
          customDiscountField.type = 'hidden';
          customDiscountField.id = 'customDiscount';
          customDiscountField.name = 'properties[__custom_discount]';
          form.appendChild(customDiscountField);
        }
        customDiscountField.value = getDiscount;
      }

      if(variant_quantity!="" && variant_quantity!=undefined){
        // --- Custom Main Price ---
        let customQuantityField = form.querySelector('#customQuantity');
        if (!customQuantityField) {
          customQuantityField = document.createElement('input');
          customQuantityField.type = 'hidden';
          customQuantityField.id = 'customQuantity';
          customQuantityField.name = 'properties[__custom_quantity]';
          form.appendChild(customQuantityField);
        }
        customQuantityField.value = variant_quantity;
      }

    }
    

    // Update line item property Frequency
    let intervalText = radio.closest(".frqplan_name_item")?.querySelector("h4")?.textContent || "";
    let match = intervalText.match(/(\d+)/);
    if (match) {
      //freqProperty.value = `Ship every ${match[1]} days`;
    } else {
      //freqProperty.value = ""; // one-time or fallback
    }
  }

  function updateAllPlanDaysPrice(radio) {
    if (radio) {
      var variant_quantity = radio.getAttribute('data-quantity');
      var getDiscount = radio.getAttribute('data-discount');
      var priceMain = radio.getAttribute('data-price');
      var comparePrice = radio.getAttribute('data-c-price');
      var discountDays = radio.getAttribute('data-days');
      // Auto-select the first option only
      var calc_main_price = priceMain;
      if(getDiscount!="" && getDiscount!=undefined && priceMain!="" && priceMain!=undefined){
        var amount_discount = (priceMain*getDiscount);
        var amount_discount = (amount_discount/100);
        calc_main_price = (priceMain-amount_discount);
        comparePrice = priceMain; 
      }

      var final_compare_price = 0;
      var final_main_price = 0;
      if(comparePrice!=undefined && comparePrice!=""){
        final_compare_price = (parseInt(comparePrice)*parseInt(variant_quantity));
        var compareDaysPrice = (final_compare_price/discountDays);
        //console.log("compareDaysPrice",compareDaysPrice);
        compareDaysPrice = Math.floor(compareDaysPrice);
        //console.log("compareDaysPrice",compareDaysPrice);
        compareDaysPrice = Shopify.formatMoney(compareDaysPrice);
        var parentBox = radio.closest('.frqplan_name_item');
        var compareTextBox = parentBox.querySelector('.frqplan_compareprice');
        if (compareTextBox) {
          compareTextBox.textContent = compareDaysPrice;
        }
      }
      if(calc_main_price!=undefined && calc_main_price!=""){
        final_main_price = (parseInt(calc_main_price)*parseInt(variant_quantity));
        var mainDaysPrice = (final_main_price/discountDays);
        mainDaysPrice = Math.floor(mainDaysPrice);
        //console.log("mainDaysPrice",mainDaysPrice);
        mainDaysPrice = Shopify.formatMoney(mainDaysPrice);
        var parentBox = radio.closest('.frqplan_name_item');
        var mainPriceTextBox = parentBox.querySelector('.frqplan_discountedprice');
        if (mainPriceTextBox) {
          mainPriceTextBox.textContent = mainDaysPrice + '/day';
        }
      }
    }
  }

  // Run on load
  setTimeout(function(){
    updatePlans();
  },1000);

  // When dog size changes
  if (sizeSelect != null) {
    sizeSelect.addEventListener("change", updatePlans);
  }

  // When frequency radio changes manually
  document.querySelectorAll(".selling-plan-radio").forEach(radio => {
    radio.addEventListener("change", function () {
      updateHiddenSellingPlan(this);
    });
  });
}); 

// PRODUCT STICKY -- START
document.addEventListener('scroll', function() {
  const target = document.querySelector('.product-details .buy-buttons-block');
  const stickySection = document.querySelector('.section.product_sticky_atc');

  if (!target || !stickySection) return;

  const targetRect = target.getBoundingClientRect();
  const targetBottom = targetRect.bottom + window.scrollY;
  const scrollTop = window.scrollY;

  if (scrollTop > targetBottom) {
    stickySection.classList.add('active');
  } else {
    stickySection.classList.remove('active');
  }
});
// PRODUCT STICKY -- END

// INGREDIENTS SHOW HIDE -- START
document.addEventListener('DOMContentLoaded', function() {
  const moreBtns = document.querySelectorAll('.button.Ingredients_smore_btn');
  const faqSections = document.querySelectorAll('.ingredients_faq.hide');

  moreBtns.forEach(function(btn) {
    btn.addEventListener('click', function(event) {
      event.preventDefault(); // stop jumping to top
      
      faqSections.forEach(function(faq) {
        faq.classList.add('active');
      });

      btn.style.display = 'none'; // hide only clicked button
    });
  });
});
// INGREDIENTS SHOW HIDE -- ENd

//PDP PAGE ADD TO CART ONE TIME PURCHASE CODE START
document.addEventListener('DOMContentLoaded', function() {
  const oncePurchase = document.querySelectorAll('.buy-once-wrapper a');

  oncePurchase.forEach(function(btn) {
    btn.addEventListener('click', function(event) {
      event.preventDefault(); // stop jumping to top
      var sellingInput = document.querySelector('.buy-buttons-block [name="selling_plan"]');
      sellingInput.value="";
      if(document.querySelector('.buy-buttons-block #hiddenSellplanid')!=null){
        var hiddenGetInput = document.querySelector('.buy-buttons-block #hiddenSellplanid').value;
        setTimeout(function(){
          var formButton = document.querySelector('.buy-buttons-block .shopify-product-form');
          if(formButton){
            const addBtn = formButton.querySelector('button[name="add"]');
            if (!addBtn) return;
            addBtn.click();
            setTimeout(function(){
              sellingInput.value=hiddenGetInput;
            },5000);
          }
        },200);
      }
    });
  });
});
//PDP PAGE ADD TO CART ONE TIME PURCHASE CODE END 

//CART DRAWER ONETIME PURCHASE PRODUCT UPGRADE FOR SUBSCRIPTION ONLY ONE QUANTITY PRODUCT AND COUNT PRODUCT ONE START
document.addEventListener('change', async function (event) {
  if (!event.target.classList.contains('subscription-upgrade')) return;
  showDrawerLoader();
  const newVariantId = event.target.value;
  const sellingPlanId   = event.target.getAttribute('data-sellingid');
  const customDiscount   = event.target.getAttribute('data-custom-discount');
  const customQuantity   = event.target.getAttribute('data-custom-quantity');

  const cart = await fetch('/cart.js').then(res => res.json());

  if (cart.items.length === 0) return;

  const item = cart.items[0];  // you said cart always 1 item
  const lineKey = item.key;
  const qty = item.quantity;

  // 2. Remove old variant
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: lineKey,
      quantity: 0
    })
  });

  // 3. Add new variant from radio button
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: newVariantId,
      quantity: qty,
      selling_plan: sellingPlanId,
      properties: {
        "Frequency": "",
        "__custom_selling_id": sellingPlanId,
        "__custom_discount": customDiscount,
        "__custom_quantity": customQuantity
      }
    })
  });

  // 4. Refresh your cart drawer (depends on your theme)
  const updatedCart = await fetch('/cart.js').then(r => r.json());
  hideDrawerLoader();
  // 4. Dispatch cart:update with VALID structure
  document.dispatchEvent(new CustomEvent('cart:update', {
    bubbles: true,
    detail: {
      resource: updatedCart,
      sourceId: 'selling-radio',
      data: {
        didError: false,
        source: 'selling-radio',
        itemCount: updatedCart.item_count,
        sections: {}   // or add your drawer sections here
      }
    }
  }));

});
//CART DRAWER REMOVE PRODUCT FUNCTION START
  function removeLineItem(btn) {
    showDrawerLoader();
    const key = btn.dataset.key;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: 0
      })
    })
    .then(res => res.json())
    .then(data => {
      // Reload cart drawer OR whole page
      const updatedDataCart = fetch('/cart.js').then(r => r.json());
      hideDrawerLoader();
      // 4. Dispatch cart:update with VALID structure
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: updatedDataCart,
          sourceId: 'selling-radio',
          data: {
            didError: false,
            source: 'selling-radio',
            itemCount: updatedDataCart.item_count,
            sections: {}   // or add your drawer sections here
          }
        }
      }));
    })
    .catch(err => console.error(err));
  }
//CART DRAWER REMOVE PRODUCT FUNCTION END

//CART DRAWER LOADER FUNCTION FOR SHOW HIDE START
function showDrawerLoader() {
  document.getElementById("drawer-loader").classList.remove("hidden");
}

function hideDrawerLoader() {
  setTimeout(function(){
    document.getElementById("drawer-loader").classList.add("hidden");
  },2000);
}
//CART DRAWER LOADER FUNCTION FOR SHOW HIDE END

//CART DRAWER ONETIME PURCHASE PRODUCT UPGRADE FOR SUBSCRIPTION ONLY ONE QUANTITY PRODUCT AND COUNT PRODUCT ONE END